import produce from 'immer';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H5 } from 'UIComponents/elements/headings';
import * as MetaTypeIds from 'automation-ui-references/object-types/InboundDbMetaTypeIds';
import WebhookManagementView from 'automation-ui-enrollment/components/eventEnrollment/webhooks/WebhookManagementView';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WebhookSelectionStep = ({
  objectTypeId,
  stagedChanges,
  setStagedChanges,
  setPanelStep
}) => {
  const handleSelectWebhook = webhook => {
    const webhookEventFilter = {
      eventTypeId: `${MetaTypeIds.PORTAL_SPECIFIC_EVENT}-${webhook.eventTypeId.innerId}`,
      filterBranches: [],
      filterBranchOperator: 'AND',
      filterBranchType: 'UNIFIED_EVENTS',
      filters: [{
        filterType: 'CONSTANT',
        shouldAccept: true
      }],
      coalescingRefineBy: {
        type: 'SetOccurrencesRefineBy',
        setType: 'ANY'
      }
    };
    if (!stagedChanges.triggers) {
      setStagedChanges(Object.assign({}, stagedChanges, {
        triggers: {
          filterBranches: [{
            filterBranches: [webhookEventFilter],
            filterBranchOperator: 'AND',
            filterBranchType: 'AND',
            filters: []
          }],
          filterBranchOperator: 'OR',
          filterBranchType: 'OR',
          filters: []
        }
      }));
    } else {
      setStagedChanges(Object.assign({}, stagedChanges, {
        triggers: produce(stagedChanges.triggers, newTriggers => {
          newTriggers.filterBranches.push({
            filterBranches: [webhookEventFilter],
            filterBranchOperator: 'AND',
            filterBranchType: 'AND',
            filters: []
          });
        })
      }));
    }
    setPanelStep('ENROLLMENT_REVIEW');
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(H5, {
      className: "m-bottom-6",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.redesign.events.webhookEvents.header"
      })
    }), /*#__PURE__*/_jsx(WebhookManagementView, {
      objectTypeId: objectTypeId,
      onSelectWebhook: handleSelectWebhook
    })]
  });
};
export default WebhookSelectionStep;